export class SetPlannerProjectModel {
    plannerId: number;
    projectId: number;
    customPlan: string;
}